/**
 * The steps of the signup funnel. The URL is the source of truth for the step,
 * so refresh, browser back/forward, and direct links all land on the right
 * step; the entry step is the bare `/signup`.
 */
export type SignupStep =
  | 'index'
  | 'password'
  | 'company'
  | 'confirmation'
  | 'onboarding_usage'
  | 'channels'
  | 'startup_complete';

const STEP_TO_SEGMENT: Record<SignupStep, string> = {
  index: '',
  password: 'password',
  company: 'company',
  confirmation: 'confirmation',
  onboarding_usage: 'onboarding-usage',
  channels: 'channels',
  startup_complete: 'startup-complete',
};

const SEGMENT_TO_STEP = new Map<string, SignupStep>(
  // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
  Object.entries(STEP_TO_SEGMENT).map(([step, segment]) => [segment, step as SignupStep]),
);

/** `null` marks an unknown segment (retired step, stale link) — the route redirects it. */
export function stepFromSplat(splat: string | undefined): SignupStep | null {
  const segment = (splat ?? '').split('/')[0];
  return SEGMENT_TO_STEP.get(segment) ?? null;
}

export function splatForStep(step: SignupStep): string {
  return STEP_TO_SEGMENT[step];
}
